import React, { useEffect, useState } from "react";
import { FaEye, FaRegHeart, FaRegStar, FaStar } from "react-icons/fa";
import { FaCodeCompare } from "react-icons/fa6";
import { RiShoppingCartLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { getAllProducts } from "../apis/config";
import ProductCard from "./ProductCard";
import ProductSkeleton from "./UI/ProductSkeleton";

const NewProducts = () => {
  const navigate = useNavigate()
  const [products,setProducts] = useState([])
  const [loading,setLoading] = useState(true)
  useEffect(() => {
    getAllProducts()
      .then((res) => {
        setProducts(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);
  const filterProducts = products.reverse().filter(pro=>pro.label.some(p=>p.toLowerCase()==='new'))
  return (
    <div className=" w-full p-5 md:p-5 md:px-10">
      <div className=" text-center">
        {/* <span className=" text-[15px] text-gray-700">Today is lastest's</span> */}
        <h3 className=" text-[25px] font-bold">New Arrivals</h3>
      </div>
      <div className=" grid grid-cols-2 md:grid-cols-4 justify-between py-10 gap-3">
        {loading
          ? Array(4)
              .fill(0)
              .map((_, index) => <ProductSkeleton key={index} />)
          : filterProducts.slice(0, 4).map((data, index) => (
              <ProductCard key={index} data={data} />
          // <div key={index} className="flex w-[166px] md:w-[261px] mx-auto flex-col justify-center items-center" onClick={()=>navigate(`/products/${data.id}`)}>
          //   <div className=" w-[166px] md:w-[261px] rounded-md relative flex justify-center items-center overflow-hidden">
          //     <img
          //       src={data.image}
          //       alt="product"
          //       className=" w-full h-full object-cover object-center rounded-md hover:scale-110 duration-200 ease-in"
          //     />
          //     <div className=" bg-white rounded-md absolute md:h-[45px] bottom-5 flex">
          //       <div className=" p-2 w-[36px] md:w-[55px] flex justify-center items-center hover:text-white hover:bg-black border-r-[1px] rounded-l-md cursor-pointer">
          //         <RiShoppingCartLine />
          //       </div>
          //       <div className=" p-2 w-[36px] md:w-[55px] flex justify-center items-center hover:text-white hover:bg-black border-r-[1px] cursor-pointer">
          //         <FaRegHeart />
          //       </div>
          //       <div className=" p-2 w-[36px] md:w-[55px] flex justify-center items-center hover:text-white hover:bg-black border-r-[1px] cursor-pointer">
          //         <FaCodeCompare />
          //       </div>
          //       <div className=" p-2 w-[36px] md:w-[55px] flex justify-center items-center hover:text-white hover:bg-black rounded-r-md cursor-pointer">
          //         <FaEye />
          //       </div>
          //     </div>
          //     <span className=" bg-red-600 absolute text-[10px] px-2 py-1 text-white capitalize font-bold left-0 top-5">
          //       {data.label}
          //     </span>
          //   </div>
          //   <div className=" flex flex-col w-full gap-1 py-2">
          //     <span className=" text-[12px] text-gray-600 capitalize">
          //       {data.category}
          //     </span>
          //     <div className="flex items-center mt-1  text-gray-600">
          //       {[1, 2, 3, 4, 5].map((index) =>
          //         index <= data.rate ? (
          //           <FaStar key={index} color="#ffa569" />
          //         ) : (
          //           <FaRegStar key={index} />
          //         )
          //       )}
          //     </div>
          //     <h4 className=" text-[15px] font-bold hover:text-purple-600 cursor-pointer w-fit">
          //       {data.title}
          //     </h4>
          //     <h4 className=" text-[15px] font-boldw-fit text-red-600 font-bold">
          //       {" "}
          //       &#8377; {data.sellPrice}{" "}
          //       <span className=" line-through text-gray-700 font-normal text-[12px]">
          //         &#8377; {data.mrp}
          //       </span>
          //     </h4>
          //   </div>
          // </div>
        ))}
      </div>
    </div>
  );
};

export default NewProducts;
